const verticalTablesSelector = '.content-table_vertical, .content-table_vertical_without-header';
const horizontalTablesSelector = '.content-table_horizontal, .content-table_horizontal_header-colored';
const fullWidthClass = 'content-table_full-width';

function resetTableItemHeight(tableItems) {
    tableItems.forEach((item) => {
        const itemElem = item.style;

        itemElem.height = '';
    });
}

function setTableItemHeights(mobileTransformTables: NodeListOf<Element>) {
    mobileTransformTables.forEach((table) => {
        const tableRows = table.querySelectorAll('tr');
        const maxHeights: number[] = [];
        const tableItems = table.querySelectorAll('td, th');

        resetTableItemHeight(tableItems);

        // Get the height for each column
        tableRows.forEach((row) => {
            const rowItems = row.querySelectorAll('td, th');

            rowItems.forEach((item, i) => {
                const itemRect = item.getBoundingClientRect();

                if (!maxHeights[i] || itemRect.height > maxHeights[i]) {
                    maxHeights[i] = itemRect.height;
                }
            });
        });

        // Set the height of each cell in each column to the maximum height for that column
        tableRows.forEach((row) => {
            const rowItems = row.querySelectorAll('td, th');

            rowItems.forEach((item, i) => {
                const itemElem = item as HTMLElement;

                itemElem.style.height = `${maxHeights[i]}px`;
            });
        });
    });
}

function setTableWidth(tables: NodeListOf<Element>) {
    tables.forEach((table) => {
        const bodyRows = table.querySelectorAll('tbody tr');
        const allRows = bodyRows.length;
        const bodyRowsWidth = `${100 / allRows}%`;

        bodyRows.forEach((row: HTMLElement) => {
            // eslint-disable-next-line no-param-reassign
            row.style.width = bodyRowsWidth;
        });
    });
}

// eslint-disable-next-line max-len
function setTableBoxShadows(verticalTables: NodeListOf<Element>, horizontalTables: NodeListOf<Element>) {
    horizontalTables.forEach((table) => {
        const tableBody = table.querySelector('.content-table__body') as HTMLElement;

        if (tableBody) {
            const isScrollable = tableBody.scrollWidth > tableBody.offsetWidth;

            table.classList.toggle(fullWidthClass, !isScrollable);
        }
    });

    verticalTables.forEach((table: HTMLElement) => {
        const contentTable = document.querySelector('.content-table__table') as HTMLElement;

        if (contentTable) {
            const isScrollable = contentTable.scrollWidth > table.offsetWidth;

            table.classList.toggle(fullWidthClass, !isScrollable);
        }
    });
}

let timeoutId;

window.addEventListener('load', () => {
    const verticalTables = document.querySelectorAll(verticalTablesSelector);
    const horizontalTables = document.querySelectorAll(horizontalTablesSelector);

    setTableWidth(horizontalTables);
    setTableItemHeights(horizontalTables);
    setTableBoxShadows(verticalTables, horizontalTables);

    window.addEventListener('resize', () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(() => {
            setTableWidth(horizontalTables);
            setTableItemHeights(horizontalTables);
            setTableBoxShadows(verticalTables, horizontalTables);
            timeoutId = null;
        }, 10);
    });
});

export {};
